import { apiService } from './apiService';
import {Branch} from '../dtos/Branch'
import { ServiceResponse } from './serviceResponse';
import { ApiError } from './apiError';
import axios, { AxiosError } from 'axios';
import { Roles } from '../dtos/Roles';


/**
 * Manejador de errores centralizado.
 * Convierte un error (potencialmente de Axios) en nuestro objeto ApiError estandarizado.
 * @param err - El error capturado en el bloque catch.
 * @returns Un objeto ApiError.
 */
const handleApiError = (err: unknown): ApiError => {
  if (axios.isAxiosError(err)) {
    const error = err as AxiosError<ApiError>;
    // Si el backend envía un objeto de error con 'message', úsalo.
    const errorMessage = error.response?.data?.message || 'Ocurrió un error en el servidor.';
    return {
      message: errorMessage,
      status: error.response?.status,
      details: error.response?.data?.details || null,
    };
  }
  // Para errores que no son de Axios (ej. de red, de código, etc.)
  return {
    message: 'Ocurrió un error inesperado. Revisa tu conexión de red.',
  };
};

/**
 * Obtiene la lista completa de usuarios.
 */
const getBranch = async (): Promise<ServiceResponse<Branch[]>> => {
  try {
    const users = await apiService.get<Branch[]>('/api/Catalogos/Sucursales');
    return { data: users, error: null };
  } catch (err) {
    return { data: null, error: handleApiError(err) };
  }
};

const getRoles = async(): Promise<ServiceResponse<Roles[]>> =>{
    try {
        const rol = await apiService.get<Roles[]>('/api/Catalogos/Roles');
        return {data: rol, error: null};
    } catch (error) {
        return {data: null, error: handleApiError(error)};
    }
}

export const catalogoService = {
    getBranch,
    getRoles
}